/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export class Health {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Verify that the API is running correctly.
   *
   * @tags Health
   * @name HealthCheckHealthGet
   * @summary Health Check
   * @request GET:/health
   */
  healthCheckHealthGet = (params = {}) =>
    this.http.request({
      path: `/health`,
      method: "GET",
      format: "json",
      ...params,
    });
}
